import styled from "styled-components";

const SideBarAccount = styled.div`
  padding:12px;
  color: #ffffff;
  background: #111823;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius:10px;
  width: 244px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
.dropDownHeading{
  padding: 6px 20px;
  font-family: Poppins;
font-size: 9px;
font-weight: 600;
line-height: 18px;
letter-spacing: 0.04em;
text-align: left;
color: rgba(255, 255, 255, 0.5);
}
.avater1 {
    background: #2dce6e;
    margin-right: 10px;
    font-size: 14px;
    width: 26px;
    height: 26px;
    min-width: 26px;
    min-height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;

    &.ant-avatar-image {
      background: transparent;
    }

    .ant-avatar-image {
      width: 100%;
      height: 100%;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      margin-right: 0;
    }
}
.spanner3 {
  color: white;
  text-transform: uppercase;
}
.menuLinks{
  max-height: calc(40.17px * 3);
  overflow-y: auto;
}
.menuDiv{
  padding: 8px;
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor:pointer;
  transition: all 0.3s ease;
}
.menuDiv:hover{
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}
.menuDiv.active,.menuDiv:hover{
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

.menuDiv.disabled:hover{
  color: rgba(255, 255, 255, 0.7);
  cursor:not-allowed;
  background:transparent;
}
.menuDiv .imageName{
  display:flex;
  align-items:center;
  font-size: 12px;
}
.menuLinks .ticIcon{
  opacity:0;
}
.menuDiv.active .ticIcon{
  opacity:1;
}
.menuLinks{
}
hr{
  border: 0.5px solid rgba(255, 255, 255, 0.08);
  margin-bottom:12px;
  margin-top:12px;
}
.settingSVG{
  margin-right: 14px;

}

`;
export { SideBarAccount };
